module.exports = __webpack_public_path__ + "3e67c782c813586b721c8b24e6bd78f8.svg";